<template>
	<div class="business">
		<div class="fx-header">
			<p>企业设置</p>
		</div>
		<div class="business-body">
            <div class="fx-title">
                <span>基本信息</span>
            </div>
            <div class='business-picture'>
                <uploadBox
                class="banner-img"
                @save='save'
                @isFalse='isFalse'
				:imgSrc.sync="ruleForm.imgurl"
                :dataid= "ruleForm.id"
				:uploadError.sync="uploadError"
				:editDisable="AuthorityList['01_0002_0001_00']"
				ref="bannerUpload"></uploadBox>
                <p style="color:#606266b5;margin-top:10px">80*80,1M以内，png/jpg/jpeg格式</p>
            </div>
            <el-form :model="ruleForm" :rules="rules" :inline-message='true' ref="ruleForm" label-position='right' label-width="114px" class="box">
                <el-form-item label="企业名称:" prop='orgname'>
					<el-input class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.orgname" :maxlength='
                    20'></el-input>
                    <!-- {{ruleForm.orgname}} -->
                </el-form-item>
                <el-form-item label="企业简称:">
                    <el-input class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.abbreviation" :maxlength='20'></el-input>
                </el-form-item>
                <el-form-item label="注 册 码:">
                    <span style="width: 260px;display: inline-block">{{ruleForm.syscode}}</span>
					<span>门店号（c号）: {{ruleForm.storecode}}</span>
                </el-form-item>
                <el-form-item label="企业编号:">
                    <span>{{ruleForm.code}}</span>
                </el-form-item>
				<el-form-item label="开通时间:">
                    <span style="width: 260px;display: inline-block">{{ruleForm.opendate}}</span>
					<span>到期时间: {{ruleForm.expiretiondate}}</span>
                </el-form-item>
                <div class="fx-title">
                    <span>联系人</span>
                </div>
                <el-form-item label="联系人姓名:" prop='linkman'>
                    <el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.linkman" :maxlength='
                    8'></el-input>
                </el-form-item>
                <el-form-item label="联系人手机号:" prop='tel'>
                    <el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.tel"></el-input>
                </el-form-item>
                <el-form-item label="联系人邮箱:" prop='email'>
                    <el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.email"></el-input>
                </el-form-item>
                <div class="fx-title">
                    <span>企业地址</span>
                </div>
                <el-form-item label="区 域:" prop='area'>
                    <el-select v-model="ruleForm.area" size='mini' class='select-box1' v-if="AuthorityList['01_0002_0001_00']"  @change='areaChange("ruleForm")'>
                        <el-option
                            v-for="item in areaList"
                            :key="item.code"
                            :label="item.name"
                            :value="item.code">
                        </el-option>
                    </el-select>
					<el-input  class='input-box' v-else size='mini' :disabled="true" v-model="area"></el-input>
                </el-form-item>
                <el-form-item label="位 置:" prop='postion' ref="postion">
                    <el-select v-model="ruleForm.province" size='mini' class='select-box region' v-if="AuthorityList['01_0002_0001_00']"  @change='provinceChange("ruleForm")' placeholder="请选择省份">
                        <el-option
                            v-for="item in provinceList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
					<el-input  class='input-box' v-else size='mini' :disabled="true" v-model="province"></el-input>
                    <el-select v-model="ruleForm.city"  size='mini' class='select-box' @change='cityChange("ruleForm")' v-if="AuthorityList['01_0002_0001_00']"  placeholder="请选择城市">
                        <el-option
                            v-for="item in cityList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
					<el-input  class='input-box' v-else size='mini' style="margin-left:20px" :disabled="true" v-model="city"></el-input>
                </el-form-item>
                <el-form-item label="地 址:" prop='address'>
                    <el-input  class='input-box-address' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.address"></el-input>
                </el-form-item>
				<div class="fx-title">
					<span>商龙云信息</span>
				</div>
				<el-form-item label="商龙云集团号:">
					<el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.groupcode"></el-input>
				</el-form-item>
				<el-form-item label="商龙云集团名称:">
					<el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.groupname"></el-input>
				</el-form-item>
				<!-- <div v-if='clddock === 1'>
					<div class="fx-title">
						<span>云供应链信息</span>
					</div>
					<el-form-item label="云供应链域名:">
						<el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00'] ||ruleForm.cldpullflag === 1" size='mini' v-model="ruleForm.clddbname"></el-input>
					</el-form-item>
					<el-form-item label="ENT号:">
						<el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00'] ||ruleForm.cldpullflag === '1'" size='mini' v-model="ruleForm.cldentno"></el-input>
					</el-form-item>
					<el-form-item label="admin密码:">
						<el-input  class='input-box' :disabled="!AuthorityList['01_0002_0001_00']" size='mini' v-model="ruleForm.cldpassword"></el-input>
					</el-form-item>
				</div> -->

                <div class="fx-title">
                    <span>企业简介</span>
                </div>
                <el-form-item label="">
                    <el-input type="textarea" size='mini' :disabled="!AuthorityList['01_0002_0001_00']" v-model="ruleForm.organinfo" :rows='3' :maxlength='300' placeholder='300字以内'></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="business-foot" :disabled="AuthorityList['01_0002_0001_00']">
            <el-button class="btn" plain type="primary" size='small' @click="cancel">取消</el-button>
            <el-button class="btn" plain type="primary" size='small' @click="submitForm('ruleForm')">保 存</el-button>
        </div>
	</div>
</template>

<script>
import uploadBox from '@/components/businessCenter/Upload.vue'
import { cityData } from '@/js/location/city.js'
import { provinceData } from '@/js/location/province.js'
import { geography } from '@/js/location/geography.js'
// import { areaData } from '@/js/location/area.js'
export default {
	name: 'business',
	components: {
		uploadBox
	},
	data () {
		var postion = (rule, value, callback) => {
			if (this.isTrue === true) {
				return callback(new Error('请选择位置'))
			} else {
				callback()
			}
		}
		var area = (rule, value, callback) => {
			if (this.waringArea === true) {
				return callback(new Error('请选择位置'))
			} else {
				callback()
			}
		}
		var phone = (rule, value, callback) => {
			var reg = /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(19[0-9]{1}))+\d{8})$/
			if (!(reg.test(value))) {
				return callback(new Error('请输入正确手机号'))
			} else {
				callback()
			}
		}
		var isNull = (rule, value, callback) => {
			var reg = /^[\s\S]*.*[^\s][\s\S]*$/
			if (!(reg.test(value))) {
				return callback(new Error(''))
			} else {
				callback()
			}
		}
		return {
			AuthorityList: {
				'01_0002_0001_00': false
			},
			// clddock: '',
			src: '',
			area: '',
			province: '',
			city: '',
			uploadError: false,
			provinceListTotal: [],
			provinceList: [],
			cityList: [],
			areaList: [],
			regionList: [],
			isTrue: true,
			isWaring: false,
			waringArea: true,
			imgId: '',
			ruleForm: {
				clddbname: '',
				// cldentno: '',
				cldpassword: '',
				cldpullflag: '',
				imgurl: '',
				id: '',
				orgname: '',
				abbreviation: '',
				province: '',
				city: '',
				syscode: '',
				opendate: '',
				expiretiondate: '',
				code: '',
				area: '',
				name: '',
				organinfo: '',
				linkman: '',
				tel: '',
				address: '',
				region: '',
				groupcode: '',
				groupname: '',
				storecode: ''
			},
			rules: {
				orgname: [
					{ required: true, validator: isNull, message: '请输入企业名称', trigger: 'blur' }
				],
				linkman: [
					{ required: true, validator: isNull, message: '请输入联系人', trigger: 'blur' }
				],
				address: [
					{ required: true, validator: isNull, message: '请输入地址', trigger: 'blur' }
				],
				area: [
					{ required: true, validator: area, trigger: 'blur' }
				],
				postion: [
					{ required: true, validator: postion, trigger: 'blur' }
				],
				email: [
					{ type: 'email', required: true, message: '请输入正确的邮箱', trigger: 'blur' }
				],
				tel: [
					{ required: true, validator: phone, trigger: 'blur' }
				]
			},
			fxDataVerification: this.$fxUtils.fxDataVerification()
		}
	},
	created () {
		this.provinceListTotal = provinceData.RECORDS
		this.provinceList = provinceData.RECORDS
		this.areaList = geography
		this.getAuthority('01_0002_0000_00')
		this.init()
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		cancel () {
			this.ruleForm.imgurl = ''
			this.$nextTick(function () {
				this.init()
			})
			this.$refs.bannerUpload.flagChange()
		},
		isFalse (data) {
			if (data === true) {
				this.$message.error('请上传图片')
			}
		},
		save (data) {
			this.ruleForm.imgurl = data
			this.ruleForm.name = this.ruleForm.orgname
			const logger = this.$fxLogger.createInfo('seller.company-settging.update', this.createLoggerParams())
			// console.log(logger)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/updateOrgan`,
				data: this.ruleForm,
				logger
			}).then(res => {
				if (res.result) {
					this.init()
					this.$refs.bannerUpload.flagChange()
					this.$message.success('保存成功！')
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		createLoggerParams () {
			const originData = this.fxDataVerification.getOriginData()
			originData.areaName = this.getAreaName(originData.area)
			originData.positionName = this.getPositionName(originData)
			const ruleForm = this.$fxUtils.deepClone(this.ruleForm)
			ruleForm.areaName = this.getAreaName(ruleForm.area)
			ruleForm.positionName = this.getPositionName(ruleForm)
			return {
				pre: originData,
				cur: ruleForm
			}
		},
		getAreaName (code) {
			if (!code) {
				return ''
			}
			return (this.areaList.find(item => {
				return item.code === code
			}) || {}).name
		},
		getPositionName ({ province, city }) {
			if (!province || !city) {
				return ''
			}
			const _province = (this.provinceList.find(item => {
				return item.id === province
			}) || {}).name
			const _city = (this.cityList.find(item => {
				return item.id === city
			}) || {}).name
			return `${_province}-${_city}`
		},
		init () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/get/organInfo`
			}).then(res => {
				console.log(res.storecode)
				// this.clddock = res.clddock
				this.ruleForm = {
					imgurl: res.imgurl,
					id: res.id,
					orgname: res.orgname,
					abbreviation: res.abbreviation,
					province: res.province,
					city: res.city,
					syscode: res.syscode,
					opendate: res.opendate,
					expiretiondate: res.expiretiondate,
					storecode: res.storecode,
					code: res.code,
					area: res.area,
					name: res.name,
					organinfo: res.organinfo,
					linkman: res.linkman,
					tel: res.tel,
					address: res.address,
					email: res.email,
					region: res.region,
					groupcode: res.groupcode,
					groupname: res.groupname,
					clddbname: res.clddbname,
					// cldentno: res.cldentno,
					cldpassword: res.cldpassword,
					cldpullflag: res.cldpullflag
				}
				this.provinceList = []
				this.cityList = []
				let b = this.provinceListTotal
				for (let i = 0; i < b.length; i++) {
					if (b[i].areacode === this.ruleForm.area) {
						this.provinceList.push(b[i])
					}
				}
				let a = cityData.RECORDS
				for (let i = 0; i < a.length; i++) {
					if (this.ruleForm.province === a[i].pid) {
						this.cityList.push(a[i])
					}
				}
				for (let a = 0; a < this.areaList.length; a++) {
					if (this.ruleForm.area === this.areaList[a].code) {
						this.area = this.areaList[a].name
					}
				}
				for (let a = 0; a < this.provinceList.length; a++) {
					if (this.ruleForm.province === this.provinceList[a].id) {
						this.province = this.provinceList[a].name
					}
				}
				for (let a = 0; a < this.cityList.length; a++) {
					if (this.ruleForm.city === this.cityList[a].id) {
						this.city = this.cityList[a].name
					}
				}
				this.fxDataVerification.resetData(this.ruleForm)
			})
		},
		provinceChange (data) {
			this.cityList = []
			this.ruleForm.city = ''
			let a = cityData.RECORDS
			for (let i = 0; i < a.length; i++) {
				if (this.ruleForm.province === a[i].pid) {
					this.cityList.push(a[i])
				}
			}
			this.postionChange(data)
		},
		cityChange (data) {
			this.postionChange(data)
		},
		areaChange (formName) {
			if (this.ruleForm.area === '') {
				this.waringArea = true
			} else {
				this.waringArea = false
			}
			this.$refs[formName].validateField('area', (error) => {
				if (!error) {
					return true
				} else {
					return false
				}
			})
			this.ruleForm.city = ''
			this.ruleForm.province = ''
			this.provinceList = []
			this.cityList = []
			let a = this.provinceListTotal
			for (let i = 0; i < a.length; i++) {
				if (a[i].areacode === this.ruleForm.area) {
					this.provinceList.push(a[i])
				}
			}
		},
		postionChange (formName) {
			if (this.ruleForm.province === '' || this.ruleForm.city === '') {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			this.$refs[formName].validateField('postion', (error) => {
				if (!error) {
					return true
				} else {
					return false
				}
			})
		},
		submitForm (formName) {
			var regu = '^[ ]+$'
			var re = new RegExp(regu)
			if (re.test(this.ruleForm.abbreviation)) {
				this.ruleForm.abbreviation = ''
			}
			if (re.test(this.ruleForm.organinfo)) {
				this.ruleForm.organinfo = ''
			}
			if (this.ruleForm.province === '' || this.ruleForm.city === '') {
				this.isTrue = true
			} else {
				this.isTrue = false
			}
			if (this.ruleForm.area === '') {
				this.waringArea = true
			} else {
				this.waringArea = false
			}
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.$refs.bannerUpload.uploadImgHandler()
				}
			})
		},
		resetForm (formName) {
			this.ruleForm.organinfo = ''
			this.ruleForm.abbreviation = ''
			this.ruleForm.province = ''
			this.ruleForm.city = ''
			this.ruleForm.area = ''
			this.$refs[formName].resetFields()
		}
	}
}
</script>
<style lang="stylus" scoped>
.business{
    width :100%;
    min-width :720px;
    height :100%;
    display: flex;
	flex-direction: column;
    .star{
        color: #F56C6C;
        margin-right: 4px;
        width:10px;
        position: relative;
        right: 292px;
        top: 26px;
    }
    .waring{
        height :14px;
        color: #F56C6C;
        font-size: 12px;
        position: relative;
        text-align :left;
        padding-left :110px;
        bottom: 20px;
    }
    .business-body{
        height :100%;
        overflow-y :auto;
        margin-bottom :20px;
        padding-bottom :30px;
        border-radius :0px 0px 10px 10px;
        padding-left :20px;
        .business-picture{
            text-align:center;
            width :210px;
            height :200px;
            margin-left :100px
        }
        .box{
            width :680px
            .input-box{
                width :200px;
            }
            .input-box-address{
                 width :500px;
            }
            .select-box{
                width :200px;
                margin-right :20px;
            }
            .select-box1{
                width :200px;
            }
            .el-form-item >>> .el-form-item__content{
                text-align :left
                }
        }
    }
    .business-foot{
        position: relative;
        height :40px;
        margin-bottom :10px;
        width :300px
        .btn{
            width :130px;
			height :35px;
			margin-left :20px;
        }
    }
}
</style>
<style lang="stylus">
	.el-textarea__inner {
		font-family: 'Microsoft Yahei' !important
	}
</style>
